import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { LINE_GRAY } from '../colors';
import ProgressBar from '../ProgressBar';
import { MODAL_CLOSE_BUTTON_SIZE, MODAL_HORIZONTAL_PADDING, MODAL_VERTICAL_PADDING } from './constants';
import { paddingVertical } from '../style/padding-vertical';
import { paddingHorizontal } from '../style/padding-horizontal';
const Wrapper = styled.div`
  border-bottom: 1px solid ${LINE_GRAY};
  ${({
  withClose
}) => paddingHorizontal(withClose ? MODAL_CLOSE_BUTTON_SIZE : MODAL_HORIZONTAL_PADDING)}
  ${paddingVertical(MODAL_VERTICAL_PADDING)}
`;
const ProgressBarWrapper = styled.div`
  position: relative;
  width: 100%;
`;
const StyledProgressBar = styled(ProgressBar)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;
const ModalHeader = ({
  withProgress = false,
  withClose = false,
  progress = 0,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, _extends({
    withClose: withClose
  }, props)), withProgress && /*#__PURE__*/React.createElement(ProgressBarWrapper, null, /*#__PURE__*/React.createElement(StyledProgressBar, {
    progress: progress,
    small: true,
    corners: true,
    transparent: true
  })));
};
export default ModalHeader;